import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import { EntityType } from "@mapmycustomers/shared/types/entity";

import ComponentRegistry from "@app/component/FieldGrid/utils/ComponentRegistry";
import { ActivityFieldName } from "@app/util/fieldModel/ActivityFieldModel";
import { isCustomField } from "@app/util/fieldModel/impl/assert";

import ActivityPeopleField from "./ActivityPeopleField";
import ColorField from "./ColorField";
import CompaniesField from "./CompaniesField";
import CompanyField from "./CompanyField";
import DealField from "./DealField";
import EmailField from "./EmailField";
import ExternalUrlField from "./ExternalUrlField";
import FrequencyIntervalField from "./FrequencyIntervalField";
import GroupField from "./GroupField";
import LargeTextCustomField from "./LargeTextCustomField";
import OwnerField from "./OwnerField";
import PersonField from "./PersonField";
import PhoneNumberField from "./PhoneNumberField";
import RoutesField from "./RoutesField";
import SourceObjectField from "./SourceObjectField";
import TeamField from "./TeamField";
import TerritoryField from "./TerritoryField";
import TextField from "./TextField";

const registerAll = () => {
  ComponentRegistry.register(ColorField, (field) => field.name === "color");
  ComponentRegistry.register(EmailField, (field) => field.name === "email");
  ComponentRegistry.register(PhoneNumberField, (field) => field.name === "phone");
  ComponentRegistry.register(TeamField, (field) => field.hasFeature(FieldFeature.TEAM_FIELD));
  ComponentRegistry.register(GroupField, (field) => field.hasFeature(FieldFeature.GROUP_FIELD));
  ComponentRegistry.register(RoutesField, (field) => field.hasFeature(FieldFeature.ROUTE_FIELD));
  ComponentRegistry.register(TerritoryField, (field) =>
    field.hasFeature(FieldFeature.TERRITORY_FIELD)
  );
  ComponentRegistry.register(CompaniesField, (field) => {
    return field.name === "accounts";
  });
  ComponentRegistry.register(CompanyField, (field) => {
    return field.name === "account" || field.name === "parentAccount";
  });
  ComponentRegistry.register(PersonField, (field) => {
    return field.name === "contact";
  });
  // ActivityPeopleField overrides PersonField for activity context — render all contacts
  // as chips with the primary first (FR-11). Last-match-wins in the registry.
  ComponentRegistry.register(ActivityPeopleField, (field, entity) => {
    return (
      (field.name === ActivityFieldName.PERSON || field.name === ActivityFieldName.PEOPLE) &&
      entity.entity === EntityType.ACTIVITY
    );
  });
  ComponentRegistry.register(DealField, (field) => {
    return field.name === "deal";
  });
  ComponentRegistry.register(OwnerField, (field) => field.name === "user");
  ComponentRegistry.register(OwnerField, (field) => field.name === "assignee");
  ComponentRegistry.register(FrequencyIntervalField, (field) =>
    field.hasFeature(FieldFeature.FREQUENCY_INTERVAL)
  );
  ComponentRegistry.register(ExternalUrlField, (field) =>
    field.hasFeature(FieldFeature.EXTERNAL_URL_FIELD)
  );
  ComponentRegistry.register(SourceObjectField, (field) =>
    field.hasFeature(FieldFeature.SOURCE_OBJECT_FIELD)
  );
  ComponentRegistry.register(
    TextField,
    (field) => isCustomField(field) && field.customFieldData.dataType === CustomFieldDataType.TEXT
  );
  ComponentRegistry.register(
    LargeTextCustomField,
    (field) =>
      isCustomField(field) && field.customFieldData.dataType === CustomFieldDataType.LARGE_TEXT
  );
};

export default registerAll;
